export default function getQueryParam(param) {
  var result = null;
  if (window.URLSearchParams) {
    var searchParams = new URLSearchParams(window.location.search);
    result = searchParams.get(param);
  } else {
    var reg = new RegExp("(^|&)" + param + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) result = decodeURIComponent(r[2]);
  }
  return result;
}